/**
 * Template generation. Workbooks are built from the same column specs that
 * drive parsing, so template headers and expected upload headers can never
 * drift apart.
 */

/**
 * Builds a blank, formatted .xlsx template for an import definition and
 * triggers a browser download.
 *
 * @param {object} spec Import definition (see specs/)
 * @returns {Promise<void>}
 */
export const downloadTemplate = async (spec) => {
  const mod = await import('exceljs');
  const ExcelJS = mod.default ?? mod;

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(spec.sheetName);

  worksheet.columns = spec.columns.map(column => ({
    header: column.header,
    key: column.key,
    width: column.width ?? 24,
  }));

  worksheet.getRow(1).font = { bold: true };

  spec.columns.forEach((column, index) => {
    if (column.numFmt) {
      worksheet.getColumn(index + 1).numFmt = column.numFmt;
    }
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = URL.createObjectURL(blob);

  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = spec.templateFileName;
  anchor.click();

  URL.revokeObjectURL(url);
};
